import { Button } from "@material-ui/core";
import { useTranslation } from "next-i18next";

import { DialogEnum } from "@/consts";
import { useUIContext } from "@/features/common/hooks/UIContext/useUIContext";

const LoginCreateAnAccountButtons = () => {
  const { t } = useTranslation("common");
  const { openDialog } = useUIContext();
  const onClickLogin = () => openDialog(DialogEnum.Login);
  const onClickCreateAccount = () => openDialog(DialogEnum.Register);

  return (
    <div className="flex space-x-1">
      <Button
        data-test-id="LoginCreateAnAccountButtons-loginButton"
        variant="text"
        color="default"
        onClick={onClickLogin}
        style={{ color: "grey" }}
      >
        {t("common:userAuthentication.login")}
      </Button>

      <Button
        data-test-id="LoginCreateAnAccountButtons-createButton"
        variant="contained"
        color="primary"
        onClick={onClickCreateAccount}
        className="whitespace-nowrap"
      >
        {t("common:userAuthentication.createAccount")}
      </Button>
    </div>
  );
};

export default LoginCreateAnAccountButtons;
